import { COLOR, FONT_SIZE, Input as _Input } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivSearchFormBox = styled.div`
  grid-area: search-form;
  position: relative;
  height: 32px;
`;

export const FormSearchForm = styled.form`
  display: inline-flex;
`;

export const InputSearchForm = styled(_Input)`
  height: 32px;
  vertical-align: middle;
  span {
    padding-left: 16px;
  }
  input {
    font-size: ${FONT_SIZE.S}px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 8px;
    color: ${COLOR.GRAY900.code};
    width: 286px;
    &:focus {
      outline: none;
    }
    ::placeholder {
      color: ${COLOR.GRAY500.code};
    }
  }
  button:focus {
    outline: none;
  }
`;
